export type DataFilter = {field: string; value: string};

export type ResolvedDataFilter = {
  search: string;
  searchField: string;
  status: string;
};

export const resolveDataFilter = (
  service: string,
  resource: string,
  filter: DataFilter,
  statusFilter = "",
): ResolvedDataFilter => {
  const identityUsers = service === "identity" && resource === "users";
  const derivedStatusFilter = identityUsers && filter.field === "status";
  const search = derivedStatusFilter ? "" : filter.value.trim();

  return {
    search,
    searchField: search && filter.field !== "*" ? filter.field : "",
    status: identityUsers ? (derivedStatusFilter ? filter.value.trim() : statusFilter) : "",
  };
};
